/* eslint-disable @stylistic/brace-style */
import { optionsProxy } from '@vlabs/uikit';
import i18n from 'i18next';

export const REPORT_TYPE = optionsProxy.create([
  { value: 'heatmap', get label() { return i18n.t('vaReporter:константы.reports.type.heatmap'); } },
  { value: 'spaghetti', get label() { return i18n.t('vaReporter:константы.reports.type.spaghetti'); } },
]);
